import { NgModule } from '@angular/core';
import { provideStates } from '@ngxs/store';
import { ChatHeaderButtonComponent } from './components/chat-header-button/chat-header-button.component';
import { ChatApiService } from './services/chat-api.service';
import { ChatState } from './state/chat.state';

@NgModule({
  declarations: [],
  imports: [ChatHeaderButtonComponent],
  exports: [ChatHeaderButtonComponent],
  providers: [ChatApiService, provideStates([ChatState])]
})
export class ChatModule {}
